<template lang="html">
<div>
  <Nav></Nav>
  <div class="section">
    <div class="container has-text-centered">
      <b-button
        size="is-large"
        v-on:click="startNewTrace()">
        New trace
      </b-button>
    </div>
  </div>

  <div class="section">
    <TraceTable
      v-bind:user_id="id"
      v-bind:editable="true"
      v-bind:showUser="false">
    </TraceTable>
  </div>

</div>
</template>

<script>
import { mapState } from 'vuex'
import Nav from '@/components/Nav'
import TraceTable from '@/components/TraceTable'
import RecordTrace from '@/components/RecordTrace'
import api from '@/utils/api'
import {
  MMCC_TRACE_STARTED,
  MMCC_TRACE_ENDED
} from '@/utils/mmccMessageTypes'

export default {
  components: {
    Nav,
    TraceTable
  },
  data () {
    return {
      newTrace: null
    }
  },
  computed: {
    ...mapState({
      id: state => state.auth.id,
      shortName: state => state.auth.short_name
    })
  },
  methods: {
    startNewTrace () {
      console.log('new trace')

      // Create new trace object in the backend.
      api.createTrace()
        .then((newTrace) => {
          // Populate the user field.
          newTrace = newTrace.withUser()

          // Open record trace modal.
          this.$buefy.modal.open({
            component: RecordTrace,
            parent: this,
            trapFocus: true,
            canCancel: true,
            onCancel: this.abort,
            hasModalCard: true,
            fullScreen: true,
            props: {
              trace: newTrace
            },
            events: {
              abort: () => {
                this.abort()
              },
              save: () => {
                this.stop()
              }
            }
          })

          // Signal new trace is live.
          this.$socket.sendObj({
            type: MMCC_TRACE_STARTED,
            data: {
              trace_id: newTrace.id,
              user_id: newTrace.user_id,
              short_name: newTrace.user.short_name
            }
          })

          // Store in component.
          this.newTrace = newTrace
        })
    },
    stop () {
      console.log('stop')

      // Notify others.
      this.$socket.sendObj({
        type: MMCC_TRACE_ENDED,
        data: {
          trace_id: this.newTrace.id
        }
      })
    },
    abort () {
      console.log('abort')

      this.stop()

      // Delete aborted trace.
      api.deleteTrace(this.newTrace)
      this.newTrace = null
    }
  },
  mounted () {
    api.getUserData(this.id)
      .catch((response) => {
        api.showApiErrorDialog(this, response)
      })
  },
  beforeDestroy () {
    if (this.newTrace) {
      // Abort any current trace if component is destroyed.
      this.abort()
    }
  }
}
</script>
